/**
 * @param {*} stringToModify
 * Function takes a string and formats it to the pattern of
 * the first capital letter and as lower case.
 */
export const capitalizeFirstLetterOfString = (stringToModify) => {
  return stringToModify.charAt(0).toUpperCase() + stringToModify.slice(1);
};

/**
 * @param {*} arrayToModifyLetters
 * Function takes an array and formats all elements of that array when
 * they are Strings to the pattern
 * the first letter capitalized and the others lowercase.
 */
export const capitalizeFirstLetterOfArray = (arrayToModifyLetters) => {
  let arrayWithFirstLetterCapitalized = [];
  for (let i = 0; i < arrayToModifyLetters.length; i++) {
    arrayWithFirstLetterCapitalized.push(
      arrayToModifyLetters[i].charAt(0).toUpperCase() +
        arrayToModifyLetters[i].substr(1).toLowerCase()
    );
  }

  return arrayWithFirstLetterCapitalized;
};
